<!-- @format -->

<top-tag>
  <div class="contents">
    <section class="contents_area">
      <div class="container_heading">
        <h1 class="heading-01 heading_orders">確認待ちの注文</h1>
        <div class="button_link">
          <a href="{ Routes.makePath('order-tag') }">全て見る</a>
        </div>
      </div>
      <!--/.container_heading-->
      <div
        class="contents_block table_top"
        is="order-list"
        list="{ state.orders }"
      ></div>
      <!--/.contents_block-->
    </section>
    <!--/.contents_area-->

    <section class="contents_area">
      <div class="container_heading">
        <h1 class="heading-01 heading_invoices">入金待ちの請求</h1>
        <div class="button_link">
          <a href="{ Routes.makePath('invoice-tag') }">全て見る</a>
        </div>
      </div>
      <!--/.container_heading-->
      <div
        class="contents_block table_top"
        is="invoice-list"
        list="{ state.invoices }"
      ></div>
      <!--/.contents_block-->
    </section>
    <!--/.contents_area-->
    <section class="contents_area">
      <h1 class="heading-01 heading_tool">CROCOのWEBマーケティングツール</h1>
      <div class="banner_area">
        <div class="banner">
          <a
            href="https://yori-co{state.serviceBaseDomain}/hub-auth"
            target="_blank"
          >
            <div class="banner_box">
              <div class="banner_illust yorico"></div>
              <div class="banner_text">
                <div class="sarvice_name">
                  <img src="/assets/img/logo_yorico.svg" alt="yori-co" />
                </div>
                <p class="service_lead">
                  ECサイトの商品紹介文を訪問者のペルソナに合わせて差し替える
                </p>
              </div>
            </div>
            <!--banner_box-->
          </a>
        </div>
      </div>

      <div class="banner_area" style="margin-top: 20px">
        <div class="banner mini">
          <a href="https://tami-co{state.serviceBaseDomain}/" target="_blank">
            <div class="banner_box">
              <div class="banner_icon tamico"></div>
              <div class="banner_text_tool">
                <div class="sarvice_name-tool">tami-co</div>
                <p class="service_lead-left">
                  検索エンジンに好かれる記事の企画・指示書の作成に役立つツール！
                </p>
              </div>
            </div>
            <!--banner_box-->
          </a>
        </div>
        <div class="banner mini">
          <a href="https://ruri-co{state.serviceBaseDomain}/" target="_blank">
            <div class="banner_box">
              <div class="banner_icon rurico"></div>
              <div class="banner_text_tool">
                <div class="sarvice_name-tool">ruri-co</div>
                <p class="service_lead-left">
                  検索結果の類似率を調査できるWEBマーケティングツール！
                </p>
              </div>
            </div>
            <!--banner_box-->
          </a>
        </div>
      </div>
      <!--/.banner_area-->
    </section>
    <!--/.contents_area-->

    <section class="contents_area">
      <h1 class="heading-01 heading_write">編集・ライティングの仕事を依頼</h1>
      <div class="banner_area">
        <div class="banner">
          <a href="https://lp-form{state.serviceBaseDomain}/" target="_blank">
            <div class="banner_box">
              <div class="banner_illust crocodesk"></div>
              <div class="banner_text">
                <div class="sarvice_name">
                  <img src="/assets/img/logo_crocodesk.svg" alt="CROCOデスク" />
                </div>
                <p class="service_lead">PMなどフルコンサルティングで記事制作</p>
              </div>
            </div>
            <!--banner_box-->
          </a>
        </div>
      </div>
      <!--/.banner_area-->
    </section>
    <!--/.contents_area-->
  </div>
  <!--/.contents-->
  <croco-desk-agreement-modal
    modalId="croco-desk-agreement-modal"
    MenuApi="{CrocoDeskApi}"
    agree="{agree}"
  ></croco-desk-agreement-modal>
  <script>
    import di from "dependency-injection";
    import Routes from "@model/croco-desk-routes.js";
    import orderList from "@tags/parts/croco-desk/order-list.riot";
    import invoiceList from "@tags/parts/croco-desk/invoice-list.riot";
    import agreementModal from "@tags/modal/croco-desk/agreement-modal.riot";

    export default {
      components: {
        "order-list": orderList,
        "invoice-list": invoiceList,
        "croco-desk-agreement-modal": agreementModal,
      },
      state: {
        serviceBaseDomain: window.__INITIAL_PROPS__.serviceBaseDomain,
        prefetch: {},
        orders: [],
        invoices: [],
      },
      agree() {
        this.CrocoDeskApi.request("index", "send-agreement")
          .then((data) => this.CrocoDeskApi.event("agreement", "closeModal"))
          .catch((err) => alert(err));
      },
      onBeforeMount(props, state) {
        this.Routes = Routes;
        this.CrocoDeskApi = di.createApi();
        state.prefetch.order = this.CrocoDeskApi.request("order", "fetch", {
          status: "pending-verification",
          limit: 5,
        });
        state.prefetch.invoice = this.CrocoDeskApi.request("invoice", "fetch", {
          status: "unpaid",
          limit: 5,
        });
      },
      async onMounted(props, state) {
        // Mount 後にイベントを発火して、モーダルDOM未配置の取りこぼしを防ぐ
        this.CrocoDeskApi.request("index", "fetch-agreement")
          .then((data) => {
            if (!data) this.CrocoDeskApi.event("agreement", "openModal");
          })
          .catch((err) => console.error("fetch-agreement failed", err));

        const order = await state.prefetch.order;
        this.update({ orders: order.items });
        const invoice = await state.prefetch.invoice;
        this.update({ invoices: invoice.items });
      },
    };
  </script>
  <style>
    .yorico {
      background-image: url(/assets/img/ill_banner-yorico.png);
    }
  </style>
</top-tag>
